<script lang="ts">
  import { run } from "svelte/legacy";

  import { onMount } from "svelte";
  import Pikaday from "pikaday";
  import { format } from "date-fns";
  import { setFocus } from "../../helpers/helperMethods";

  interface Props {
    error?: boolean;
    autoFocus?: boolean;
    autoFocusDelay?: boolean;
    date: any;
    minDate?: any;
    endDate?: any;
    maxDate?: Date | null;
  }

  let {
    error = false,
    autoFocus = true,
    autoFocusDelay = true,
    date = $bindable(),
    minDate = new Date(),
    endDate = new Date(2100),
    maxDate = null,
  }: Props = $props();

  let container = $state();
  let picker: Pikaday = $state();

  const init = (el: HTMLInputElement) => {
    if (autoFocus) {
      setFocus(el, autoFocusDelay);
    }
  };

  onMount(() => {
    picker = new Pikaday({
      value: format(date, "MM/DD/YYYY"),
      field: container,
      minDate: minDate,
      endDate: endDate,
      maxDate: maxDate,
      onSelect: (newDate: Date) => {
        date = newDate;
      },
    });
  });

  const updateDate = (date: Date) => {
    if (date.getTime() != picker.getDate().getTime()) {
      picker.setDate(date);
    }
  };
  $effect(() => {
    if (picker) updateDate(date);
  });
</script>

<label>
  <input
    class="calander-input h-10 w-42 border p-2 rounded-md {error
      ? 'border-2 border-Red900'
      : 'border-Neutral400'} focus:border-Violet400 text-M"
    type="text"
    value={format(date, "YYYY-MM-DD")}
    bind:this={container}
  />
</label>
